import { createAsyncThunk } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import axios from 'axios';
import host from '../../global';

export const getInterviewCommentsThunk = createAsyncThunk(
    "interview/getComments",
    async (interviewId, thunkAPI) => {
        try {
            const accessToken = Cookies.get("accessToken");
            const response = await axios.get(`${host}/interview/remark/${interviewId}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            })
            const data = await response.data;
            return data;
        } catch (error) {
            // No remarks yet → 404; treat as empty
            if (error.response?.status === 404) {
                return { _id: interviewId, comments: [] };
            }
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export const addInterviewCommentThunk = createAsyncThunk(
    "interview/addComment",
    async ({ interviewId, commentContent, isAdmin }, thunkAPI) => {
        try {
            const accessToken = Cookies.get("accessToken");
            const response = await axios.post(`${host}/interview/remark/${interviewId}`,
                {
                    content: commentContent,
                    isAdmin: isAdmin
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );
            const data = await response.data;
            return data.comments[data.comments.length - 1]; // Return the newly added comment
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);


// ["SCHEDULED", "PROGRESS", "COMPLETED"]
export const getAllCandidatesForInterviewThunk = createAsyncThunk(
    "interview/getAllCandidates",
    async ({ page = 1, limit = 10, job_position = "All", search_query = "", combined_status = "All", min_score = 0, max_score = 100, filterby = "SCHEDULED", owner = "All", start_date = "", end_date = "", interview_start_filter = "", interview_end_filter = "" ,orgId , scheduleFilter="ALL"}, { rejectWithValue, signal }) => {
        try {
            const accessToken = Cookies.get("accessToken");
            console.log("ORG ID BEING SENT:", orgId);

            if (scheduleFilter === "PENDING") {
                combined_status = "Pending";
            }
            if (scheduleFilter === "IN PROGRESS") {
                combined_status = "In Progress";
            }
            if (scheduleFilter === "COMPLETED") {
                combined_status = "Completed";
            }

            const response = await axios.get(`${host}/get_candidates_data`, {
                params: {
                    page,
                    limit,
                    job_position,
                    combined_status,
                    min_score,
                    max_score,
                    filterby,
                    search_query,
                    start_date,
                    end_date,
                    interview_start_filter,
                    interview_end_filter,
                    scheduled_by_name:owner,
                    org_id:orgId,
                    scheduleFilter
                },
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                signal: signal
            });

            const { candidates, current_user_id, total_count } = response.data;

            if (!candidates || !Array.isArray(candidates)) {
                throw new Error("Invalid data format received from server");
            }

            // Ensure "Completed" candidates unconditionally ignore historical cancellation flags
            const cleansedCandidates = candidates.map((candidate) => {
                if (candidate.combined_status === 'Completed') {
                    return {
                        ...candidate,
                        isCanceled: false,
                        isRescheduled: false,
                        canceledByCandidate: false
                    };
                }
                return candidate;
            });

            return { candidates: cleansedCandidates, current_user_id, total_count, filterby };
        } catch (error) {
            if (axios.isCancel(error) || error.name === 'AbortError' || error.name === 'CanceledError') {
                console.log("Request canceled for getAllCandidatesForInterviewThunk:", error.message);
                throw error; // Let Redux Toolkit handle the abort natively
            }
            console.error("getAllCandidatesForInterviewThunk ERROR:", error);
            return rejectWithValue(error.message);
        }
    }
)


export const getJobPositionsThunk = createAsyncThunk(
    "interview/getJobPositions",
    async (_, thunkAPI) => {
        try {
            const accessToken = Cookies.get("accessToken");
            const response = await axios.get(`${host}/jobroles`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            const jobRoles = response.data;

            if (!jobRoles || !Array.isArray(jobRoles)) {
                throw new Error("Invalid data format received from server");
            }

            return jobRoles;


        } catch (error) {
            console.error("getJobPositionsThunk ERROR:", error);
            return thunkAPI.rejectWithValue(error.message);
        }
    }
)


export const getJobPositionsforDropdown = createAsyncThunk(
    "interview/getJobPositionsforDropdown",
    async (_, thunkAPI) => {
        try {
            const accessToken = Cookies.get("accessToken");
            const response = await axios.get(`${host}/getjdpositions`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            if (response.data) {
                return response.data
            }
        } catch (error) {
            console.error("Something went wrong while fetching data for getJobPositionsforDropdown")
            console.log({ error })
            return thunkAPI.rejectWithValue("Something went wrong while fetching data for getJobPositionsforDropdown")
        }
    }
)

export const getJobDescriptionThunk = createAsyncThunk(
    "interview/getJobDescription",
    async (jobId, thunkAPI) => {
        try {
            const accessToken = Cookies.get("accessToken");
            const response = await axios.get(`${host}/getjd`, {
                headers: { Authorization: `Bearer ${accessToken}` },
                params: { jd_id: jobId },
            });
            console.log({ response })
            if (response?.data) {
                console.log("Job description fetched successfully");
                return response.data;
            }

            return null;
        } catch (error) {
            console.error("Somthing Went Wrong While Fetching Job Description in Thunk");
            console.log({ error });
            thunkAPI.rejectWithValue("Somthing Went Wrong while fetching Job Description From thunk ");
        }
    }
)

export const getSourcedCandidatesThunk = createAsyncThunk(
    "candidates/getSourcedCandidates",
    async ({ jobId = "all" }, thunkAPI) => {
        try {
            const accessToken = Cookies.get("accessToken");
            const response = await axios.get(`${host}/sourced-candidates/bulk`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    jd_id: jobId,
                },
            });

            const allCandidates = response.data.candidates || [];
            return allCandidates;
        } catch (error) {
            console.log("Somthing Went Wrong while fetching data from getSourcedCandidatesThunk");
            console.log({ error });
            return thunkAPI.rejectWithValue(error.message);
        }
    }
)


export const getCandidatesForDecisionCenterThunk = createAsyncThunk(
    'interview/decisionCenter',
    async (status, thunkAPI) => {
        try {
            const accessToken = Cookies.get("accessToken");
            const response = await axios.get(`${host}/interview/candidates/decision_center?status=${status}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            )
            const { success, data } = response.data
            if (!success || !data) {
                thunkAPI.rejectWithValue("Somthing Went Wrong While Fetching Candidates");
            }

            return { data, status };
        } catch (error) {
            console.log("Somthing Went Wrong while fetching data from getCandidatesForDecisionCenter");
            console.log({ error });
            return thunkAPI.rejectWithValue(error.message);
        }
    }
)


export const getAllOwnersForInterviewThunk = createAsyncThunk(
    "interview/getAllOwnersForInterviewThunk",
    async (_, thunkApi) => {
        const allUsers = [];

        try {
            const accessToken = Cookies.get("accessToken");

            // ── 1. Fetch HR profiles ──────────────────────────────────────────
            try {
                const hrResponse = await axios.get(`${host}/orgadmin/get_hrprofiles`, {
                    headers: { Authorization: `Bearer ${accessToken}` },
                });

                let hrData = hrResponse.data;

                // Normalise: unwrap if object wrapper exists
                if (hrData && !Array.isArray(hrData)) {
                    hrData = hrData.hr_profiles || hrData.users || hrData.data || hrData.hrdetails || [];
                }

                const hrUsers = (hrData || [])
                    .map(user => ({
                        name:  user.hrName  || user.name      || user.username  || user.full_name,
                        type:  "HR",
                        id:    user.hrId    || user.id        || user.userId,
                        email: user.hremail || user.email,
                    }))
                    .filter(user => user.name);

                allUsers.push(...hrUsers);
            } catch (err) {
                console.warn("HR profiles endpoint failed:", err.message);
            }

            // ── 2. Fetch Admin details ────────────────────────────────────────
            try {
                const adminResponse = await axios.get(`${host}/getadmindetails`, {
                    headers: { Authorization: `Bearer ${accessToken}` },
                });

                const admin = adminResponse.data;

                // Response is a single object — wrap into a normalised user
                if (admin && admin.name) {
                    allUsers.push({
                        name:  admin.name,
                        type:  "Admin",
                        id:    admin.id    || null,
                        email: admin.email || null,
                    });
                }
            } catch (err) {
                console.warn("Admin details endpoint failed:", err.message);
            }

            return allUsers; // [{ name, type, id, email }, ...]

        } catch (error) {
            console.error("Error fetching owners for interview:", error);
            return thunkApi.rejectWithValue([]); // ← return was missing
        }
    }
);